import React, { createContext, useReducer } from 'react'

export const RESET_SELECTED_DTC = 'reset_select_dtc'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case 'set_dtc_list': {
      return { ...data, dtc_list: payload.data }
    }
    case 'select_dtc': {
      let selected_dtc = [...data.selected_dtc]

      let is_selected_dtc = selected_dtc.find((o) => o.id === payload.data.id)
      if (is_selected_dtc?.id) {
        let selected_dtc = data.selected_dtc.filter(function (item) {
          return item.id !== payload.data.id
        })

        return { ...data, selected_dtc: [...selected_dtc] }
      } else {
        selected_dtc.push(payload.data)
        return { ...data, selected_dtc: [...selected_dtc] }
      }
    }
    case 'reset_select_dtc': {
      return { ...data, selected_dtc: [] }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  dtc_list: [],
  selected_dtc: [],
}

const TatStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <TatContext.Provider value={[state, dispatch]}>
      {children}
    </TatContext.Provider>
  )
}

export const TatContext = createContext(initialState)
export default TatStore
